import { render, staticRenderFns } from "./AffiliateFilters.vue?vue&type=template&id=736a7613&scoped=true&"
import script from "./AffiliateFilters.vue?vue&type=script&lang=js&"
export * from "./AffiliateFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a7613",
  null
  
)

export default component.exports